/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceNotificationSignupConfig
 */
export interface SurfaceNotificationSignupConfig {
    /**
     * 
     * @type {string}
     * @memberof SurfaceNotificationSignupConfig
     */
    heading?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceNotificationSignupConfig
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof SurfaceNotificationSignupConfig
     */
    buttonText?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurfaceNotificationSignupConfig
     */
    channels?: Array<SurfaceNotificationSignupConfigChannelsEnum>;
    /**
     * 
     * @type {string}
     * @memberof SurfaceNotificationSignupConfig
     */
    successMessage?: string;
}


/**
 * @export
 */
export const SurfaceNotificationSignupConfigChannelsEnum = {
    email: 'email',
    push: 'push'
} as const;
export type SurfaceNotificationSignupConfigChannelsEnum = typeof SurfaceNotificationSignupConfigChannelsEnum[keyof typeof SurfaceNotificationSignupConfigChannelsEnum];


/**
 * Check if a given object implements the SurfaceNotificationSignupConfig interface.
 */
export function instanceOfSurfaceNotificationSignupConfig(value: object): value is SurfaceNotificationSignupConfig {
    return true;
}

export function SurfaceNotificationSignupConfigFromJSON(json: any): SurfaceNotificationSignupConfig {
    return SurfaceNotificationSignupConfigFromJSONTyped(json, false);
}

export function SurfaceNotificationSignupConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceNotificationSignupConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'heading': json['heading'] == null ? undefined : json['heading'],
        'description': json['description'] == null ? undefined : json['description'],
        'buttonText': json['buttonText'] == null ? undefined : json['buttonText'],
        'channels': json['channels'] == null ? undefined : json['channels'],
        'successMessage': json['successMessage'] == null ? undefined : json['successMessage'],
    };
}

export function SurfaceNotificationSignupConfigToJSON(json: any): SurfaceNotificationSignupConfig {
    return SurfaceNotificationSignupConfigToJSONTyped(json, false);
}

export function SurfaceNotificationSignupConfigToJSONTyped(value?: SurfaceNotificationSignupConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'heading': value['heading'],
        'description': value['description'],
        'buttonText': value['buttonText'],
        'channels': value['channels'],
        'successMessage': value['successMessage'],
    };
}

